import { getConditionalObject } from 'utils/data';

export const tableWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '4px',
  overflow: 'hidden',
};

export const headerRowStyles = {
  display: 'grid',
  gridTemplateColumns: '1fr 160px',
  alignItems: 'center',
  padding: '10px 16px',
  backgroundColor: ({ palette }) => palette.background.default,
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const getBodyRowStyles = ({ isLastRow }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 160px',
  alignItems: 'center',
  padding: '8px 16px',
  // The Total row draws its own top border, so the last body row must not double it up.
  ...getConditionalObject(!isLastRow, () => ({
    borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  })),
});

export const emptyRowStyles = {
  padding: '16px',
  textAlign: 'center',
};

export const amountCellStyles = {
  textAlign: 'right',
  paddingRight: '24px',
};

export const totalRowStyles = {
  display: 'grid',
  gridTemplateColumns: '1fr 160px',
  alignItems: 'center',
  padding: '10px 16px',
  backgroundColor: ({ palette }) => palette.background.default,
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
};
